export default "__VITE_ASSET__ae9ccf2b__"